(function ($) {
  Drupal.behaviors.lastGuideB5Comment = {
    attach (context, settings) {
      $('.field--name-field-comment textarea').on('keypress', function () {
        const $refField = $(this).closest('form').find('.field--name-field-step-comment-ref input');
        if ($refField.val() === '') {
          const refId = $(this).closest('.views-row').find('.type-comment-ref-id').attr('data-rid');
          $refField.val(refId);
        }
      });

      $(document).ajaxComplete((event, xhr, settings) => {
        const $cTarget = event.currentTarget.activeElement;
        const $cForm = $($cTarget).closest('form');
        if ($cForm.hasClass('comment-form')) {
          const cTextarea = $cForm.find('textarea');
          if (cTextarea.val() !== '') {
            cTextarea.val('');
            // const pTextarea = cTextarea.closest('.form-textarea-wrapper');
            $cForm.find('.alert-error').hide();
            $cForm.find('.js-ajax-comments-messages').hide();
            if ($cForm.prev().hasClass('js-ajax-comments-messages')) {
              $cForm.prev().hide();
            }

            $cForm.closest('.views-row').find('.js-ajax-comments-messages').hide();
            $cForm.find('.message-after-comment-post').addClass('show');
            $cForm.find('.message-after-comment-post').removeClass('hidden');
            $cForm.find('.message-after-comment-post').removeClass('fade');
          }
        }
      });

      $(document).ready(() => {
        $('.comment-sub-titles .etape-link').on('click', function () {
          const idName = $(this).attr('data-id');
          setTimeout(() => {
            $(`#${idName}`).parent().find('.icon-comment').parent()
              .trigger('click');
          }, 1200);
        });
        commentariesStepGeneration();
      });

      $(window).resize(() => {
        commentariesStepGeneration();
      });

      function commentariesStepGeneration () {
        $('.dropdown-content .dropdown .dropbtn').click(function(){
          return false;
        });
        let items = 6;
        if ($(window).width() < 1200) {
          items = 5;
        }
        if ($(window).width() < 1024) {
          items = 4;
        }

        if ($(window).width() < 980) {
          items = 3;
        }

        if ($(window).width() < 768) {
          items = 1;
        }
        if ($(window).width() < 430) {
          items = 0;
        }
        commentariesMoveToMoreSection(items);
      }

      function commentariesMoveToMoreSection (maxElements) {
        if ($('.comment-sub-titles').length) {
          $('.comment-sub-titles .menu-item').removeClass('hide-modal');
          const elements = $('.comment-sub-titles .menu-base');
          const elementsSubItems = $('.comment-sub-titles .dropdown-menu .menu-sub-item');

          if (elements.length > (maxElements + 1)) {
            $('.dropdown-content').show();
            $('.comment-sub-titles .menu-item').removeClass('hide-modal');
            elements.each(function (index) {
              if (index > maxElements) {
                $(this).addClass('hide-modal');
              }
            });

            elementsSubItems.each(function (index) {
              if (index < maxElements) {
                $(this).addClass('hide-modal');
              }
            });
          } else {
            $('.dropdown-content').hide();
          }
        }
      }
    },
  };
}(jQuery));
